import {
    OBTENER_LLAVES,
    GET_CONFIG_FORM_DESC,
    GET_TIPOS_DESCARGA,
    GET_RESPONSABLES,
    GET_CRITERIOS_FECHA_DESC,
    GET_DESC_PREVIAS,
    POST_GENERAR_DESCARGA
} from '../types';


export default function descargaCasosReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORM_DESC:
            return { ...state, cfg_formInf: action.payload }
        case GET_TIPOS_DESCARGA:
            return { ...state, tiposDescarga: action.payload }
        case GET_RESPONSABLES:
            return { ...state, responsables: action.payload }
        case GET_CRITERIOS_FECHA_DESC:
            return { ...state, criteriosFecha: action.payload }
        case GET_DESC_PREVIAS:
            return { ...state, listaDescargasPrevias: action.payload }
        case POST_GENERAR_DESCARGA:
            return { ...state, respuestaGenerar: action.payload }
        default:
            return state
    }
}